// extracted by mini-css-extract-plugin
export default {"cls1":"StyledComponents-DownloadFileInfo_cls1__mfRN1","cls2":"StyledComponents-DownloadFileInfo_cls2__fbaGM StyledComponents-DownloadFileInfo_cls1__mfRN1"};